export default "__VITE_ASSET__76a3e45a__"